import { render, staticRenderFns } from "./candidate_age_study.vue?vue&type=template&id=5cd262b4&scoped=true&"
import script from "./candidate_age_study.vue?vue&type=script&lang=js&"
export * from "./candidate_age_study.vue?vue&type=script&lang=js&"
import style0 from "./candidate_age_study.vue?vue&type=style&index=0&id=5cd262b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd262b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd262b4')) {
      api.createRecord('5cd262b4', component.options)
    } else {
      api.reload('5cd262b4', component.options)
    }
    module.hot.accept("./candidate_age_study.vue?vue&type=template&id=5cd262b4&scoped=true&", function () {
      api.rerender('5cd262b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/candidate_age_study.vue"
export default component.exports